import { Trans } from '@lingui/react/macro';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@repo/videa-components/src/index';

import type { TToothTableData } from '@/modules/claims/freeClaims/insuranceExport/types';
import { red400 } from '@/theme/videa-style-tokens';

import { FindingColorBox } from './FindingColorBox';

type ToothLevelTreatmentsTableProps = {
  tableData: TToothTableData[];
};

const getDmfPercentage = (dmf: number | null) =>
  !dmf ? '--' : `${(dmf * 100).toFixed(0)}%`;

const getIsPresent = (findingArray: string[] | null) => {
  /* Use svg directly instead of FontAwesomeIcon to avoid
  rendering issues with the icon when downloading attachment */
  return findingArray && findingArray.length > 0 ? (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 4L6 11.3333L2.66667 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    '--'
  );
};

export const ToothLevelTreatmentsTable = ({
  tableData,
}: ToothLevelTreatmentsTableProps) => {
  return (
    <Table className="vai-border vai-border-slate-200">
      <TableHeader className="vai-bg-slate-100">
        <TableRow>
          <TableHead className="vai-text-xs">
            <Trans>TOOTH</Trans>
          </TableHead>
          <TableHead className="vai-text-xs">
            <Trans>Tx CODE</Trans>
          </TableHead>
          <TableHead className="vai-text-xs">
            <Trans>TOOTH STRUCTURE LOSS</Trans>*
          </TableHead>
          <TableHead className="vai-text-xs">
            <div className="vai-flex vai-items-center vai-gap-2">
              <FindingColorBox color={red400} />
              <Trans>POTENTIAL CARIES</Trans>
            </div>
          </TableHead>
          <TableHead className="vai-text-xs">
            <div className="vai-flex vai-items-center vai-gap-2">
              <FindingColorBox color="#A8CD0C" isDotted />
              <Trans>POTENTIAL RESTORATIVE IMPERFECTIONS</Trans>**
            </div>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {tableData.map((tooth) => (
          <TableRow key={tooth.toothId}>
            <TableCell>{tooth.toothId}</TableCell>
            <TableCell>
              {Array.from(tooth.txCodes).map((code, index) => (
                <div key={index}>{code}</div>
              ))}
            </TableCell>
            <TableCell>{getDmfPercentage(tooth.dmf)}</TableCell>
            <TableCell>{getIsPresent(tooth.caries || [])}</TableCell>
            <TableCell>
              {getIsPresent(tooth.restorativeAdjacentLucency || [])}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
